import axios from "../utils/axios";
import {Organization, Permission, Role, Team, User} from "../types/userTypes";

export async function login(email: string, password: string) {
    const response = await axios.post( '/auth/login', {email, password});
    return response.data;
}

export async function logout() {
    const response = await axios.post('/auth/logout')
    return response.data;
}

export async function verifyToken() {
    const response = await axios.get(process.env.REACT_APP_BASE_URL + '/auth/verifyToken')
    return response.data
}

export async function updateUser (user: User, idUser: string) {
    const response = await axios.put(`/user/${idUser}`, user);
    return response.data;
}

export async function changePassword(idUser: string) {
    const response = await axios.post(`/user/${idUser}/password`, {password: idUser});
    return response.data;
}

export async function getUsers(): Promise<User[]> {
    const response = await axios.get(`/user/users`);
    return response.data;
}

export async function createUser(user: User){
    const response = await axios.post(`/user`, user);
    return response.data;
}

export async function deleteUser(userId: string) {
    const response = await axios.delete(`/user/${userId}`);
    return response.data;
}

export async function getRoles(): Promise<Role[]> {
    const response = await axios.get(`/user/roles`);
    return response.data;
}

export async function getRoleById(id: string): Promise<Role> {
    const response = await axios.get(`/user/role/${id}`);
    return response.data;
}

export async function createRole(role: Role): Promise<Role> {
    const response = await axios.post(`/user/role/`, role);
    return response.data;
}

export async function updateRole(id: string, role: Role): Promise<Role> {
    const response = await axios.put(`/user/role/${id}`, role);
    return response.data;
}

export async function deleteRole(id: string): Promise<Role> {
    const response = await axios.delete(`/user/role/${id}`);
    return response.data;
}

export async function getOrganizations(): Promise<Organization[]> {
    const response = await axios.get(`/user/organizations`);
    return response.data;
}

export async function createOrganization(organization: Organization): Promise<{id: string}> {
    const response = await axios.post(`/user/organization`, organization);
    return response.data;
}

export async function updateOrganization(organization: Organization): Promise<void> {
    const response = await axios.put(`/user/organization/${organization.id}`, organization);
    return response.data;
}

export async function deleteOrganization(organizationId: string): Promise<void> {
    const response = await axios.delete(`/user/organization/${organizationId}`);
    return response.data;
}

export async function getUser(userId: string): Promise<Role[]> {
    const response = await axios.get(`/user/${userId}`);
    return response.data;
}

export async function passwordChange(userId: string, password: string) {
    const response = await axios.post(`/user/${userId}/change_password`, {password: password});
    return response.data;
}

export async function getTeams(id_competitions: string[]): Promise<any> {
    const params = {id_competitions}
    const response = await axios.get(`/user/teams`, {params});
    return response.data;
}

export async function getAvailablePermissions(): Promise<Permission[]> {
    const response = await axios.get(`/user/permissions`);
    return response.data;
}


